import styled from 'styled-components';
import { greenColor, lightGrey3Color } from 'js/config/style';

const topPadding = '0.5rem';

import Label from './Label';
import Value from './Value';

export const Amount = styled(Label)`
  padding-top: ${topPadding};
  color: ${lightGrey3Color};
`;

export const Money = styled(Value)`
  padding-top: ${topPadding};
  color: ${greenColor};
`;
